const CouponModal = ({ show, onClose, coupons, onApplyCoupon }) => {
  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg overflow-hidden">
          <div className="modal-header py-3">
            <h5 className="modal-title fw-bold mb-0 text-main-600">
              <i className="ph-fill ph-ticket me-2" />
              Available Coupons
            </h5>
            <button onClick={onClose} className="btn-close" />
          </div>
          <div
            className="modal-body p-0"
            style={{ maxHeight: '420px', overflowY: 'auto' }}
          >
            {coupons.length === 0 && (
              <p className="text-center text-gray-500 py-24 mb-0">
                No coupons available right now.
              </p>
            )}
            <div className="d-flex flex-column p-20 gap-16">
              {coupons.map((coupon) => {
                const discountLabel =
                  coupon.type === 'percentage'
                    ? `${parseFloat(coupon.value)}% OFF`
                    : `₹${parseFloat(coupon.value)} OFF`;
                return (
                  <div
                    key={coupon.id}
                    className="position-relative d-flex rounded-12 overflow-hidden cursor-pointer"
                    style={{
                      border: '1.5px dashed var(--main-600)',
                      background: 'linear-gradient(135deg, #faf8ff 0%, #f3f0ff 100%)',
                      transition: 'all .2s ease',
                    }}
                    onClick={() => onApplyCoupon(coupon.code)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    {/* Left accent stripe */}
                    <div
                      style={{
                        width: '6px',
                        background: 'var(--main-600)',
                        flexShrink: 0,
                      }}
                    />

                    <div className="flex-grow-1 p-16">
                      {/* Top row: code + badge */}
                      <div className="flex-between gap-12 mb-8">
                        <span className="fw-bold font-mono text-main-700" style={{ fontSize: '15px' }}>
                          {coupon.code}
                        </span>
                        <span
                          className="fw-bold text-white px-10 py-2 rounded-6"
                          style={{ fontSize: '11px', background: '#10b981' }}
                        >
                          {discountLabel}
                        </span>
                      </div>

                      {/* Details row */}
                      <div className="d-flex align-items-center gap-16 mb-12 text-gray-600" style={{ fontSize: '12px' }}>
                        {coupon.max_discount && (
                          <span className="d-flex align-items-center gap-4">
                            <i className="ph ph-info" />
                            Max ₹{parseFloat(coupon.max_discount)}
                          </span>
                        )}
                        {coupon.min_order_amount > 0 && (
                          <span className="d-flex align-items-center gap-4">
                            <i className="ph ph-shopping-cart" />
                            Min ₹{parseFloat(coupon.min_order_amount)}
                          </span>
                        )}
                      </div>

                      {/* Apply button */}
                      <button
                        className="btn btn-main btn-sm rounded-6 w-100 fw-600"
                        style={{ background: 'var(--main-600)', border: 'none' }}
                      >
                        <i className="ph ph-check-circle me-1" /> Apply Coupon
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponModal;
